import { t as globalT } from "@lingui/core/macro";
import {
  PropertySearchResultPage,
  useSuspenseQueryPostgrest,
} from "@sweco-se/reality-frontend";
import { createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";

import { api } from "@/api.ts";

export const Route = createFileRoute("/property/search/$session")({
  component: PropertySearchResult,
  head: () => ({
    meta: [
      {
        title: globalT`Sweco REALity` + " - " + globalT`Property Search`,
      },
    ],
  }),
});

function PropertySearchResult() {
  const sessionId = Route.useParams().session;

  const { data: session } = useSuspenseQueryPostgrest(
    useMemo(
      () =>
        api
          .from("session")
          .select("id,project(name),top_level_objects,started_at,datasets")
          .eq("id", sessionId)
          .throwOnError()
          .single(),
      [sessionId],
    ),
  );

  return (
    <PropertySearchResultPage
      session={session}
      costInformation={session.project?.name ?? ""}
      show={["title", "download", "meta", "picker"]}
    />
  );
}
